<template>
    <transition name="fade">
        <div v-if="sidebarIsOpened" id="div-aside" class="column is-2 is-fullheight sidebar-default app-sidebar">
            <aside class="menu">
                <p class="menu-label sidebar-close-row">
                    <button class="delete is-small is-pulled-right" id="close-sidebar" aria-label="close" @click="SET_SIDEBAR(false)" title="Fechar o menu"></button>
                </p>
                <figure class="image is-64x64 has-image-centered is-hidden-mobile sidebar-avatar">
                    <img v-if="foto==null" class="is-rounded" src="../assets/pessoa.png">
                    <img v-else class="is-rounded" :src="foto">
                </figure>
                <h4 class="title is-6 has-text-centered is-marginless sidebar-user-name">
                    {{ usuario.apelido ?? usuario.nome }}
                </h4>
                <p class="is-size-7 has-text-centered sidebar-user-role">
                    {{ usuario.nivel }}
                </p>
                <hr class="dropdown-divider">

                
                <span>

                
                    <b-field v-if="usuario.administrador && alterandoUnidade" 
                            label="Unidade" 
                            label-position="on-border">
                        <b-select size="is-small" v-model="unidadeId"
                                expanded>
                            <option v-for="(item, index) in unidades" 
                                    v-bind:key="index" 
                                    :value="item.id">{{item.nome}}</option>
                        </b-select>
                    </b-field>
                    <p v-else class="is-size-7 has-text-centered">
                        Unidade: <b>{{unidadeNome}}</b>
                        <a v-if="usuario.administrador" href="#" class="has-text-grey" @click="alterandoUnidade = true" title="Alterar unidade">
                            <b-icon  icon="pencil" size="is-small"></b-icon>
                        </a>                    
                    </p>                    

                </span>



                <hr class="dropdown-divider">


                <ul class="menu-list">
                    
                    <li v-if="isInRole('prd-dashboard-consultar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'prd-dashboard' }" exact>
                            <b-icon icon="view-dashboard-outline" size="is-small"></b-icon> Visão geral
                        </router-link>
                    </li>
                    <li v-if="podeAcessarOrcamentos" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'prd-orcamentos' }">
                            <b-icon icon="file-document-multiple-outline" size="is-small"></b-icon> Orçamentos
                        </router-link>
                    </li>
                    <li v-if="podeAcessarAnalise" @click="HANDLE_RESIZE()">
                    <router-link :to="{ name: 'prd-analise' }">
                            <b-icon icon="clipboard-search-outline" size="is-small"></b-icon> Análise
                        </router-link>
                    </li>
                    <li v-if="podeAcessarProducao" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'prd-producao' }">
                            <b-icon icon="package-variant-closed" size="is-small"></b-icon> Produção
                        </router-link>
                    </li>
                    <li @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'pesquisar' }">
                            <b-icon icon="magnify" size="is-small"></b-icon> Pesquisar
                        </router-link>
                    </li>
                    <li v-if="isInRole('financeiro-consultar') || isInRole('financeiro-alterar')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'financeiro' }">
                            <b-icon icon="cash-multiple" size="is-small"></b-icon> Financeiro
                        </router-link>
                    </li>
                    <li class="prd-menu-separator"></li>

  
                    <li  v-if="isInRole('menu-manutencao')" @click="HANDLE_RESIZE()">
                        <router-link :to="{ name: 'manutencao' }">
                            <b-icon icon="cog" size="is-small"></b-icon> {{$t('SISTEMA.MANUTENCAO')}}
                        </router-link>
                    </li>                                      
                </ul>
                <hr class="dropdown-divider">
                <ul class="menu-list">
                    <li>
                        <a @click="logout">
                            <b-icon icon="logout" size="is-small"></b-icon>
                            {{$t('SISTEMA.SAIR')}}
                        </a>
                    </li>
                </ul>
            </aside>
        </div>
    </transition>    
</template>

<script>
    import { mapActions, mapState, mapGetters } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        data() {
            return {
                alterandoUnidade: false,
                foto: null,       
                unidadeEmpresaId:null,
            }
        },
        computed: {
            ...mapState([
                'config',
                'usuario',
                'unidadeId',
                'unidades'                
            ]),
            ...mapState('componentes', [
                'sidebarIsOpened'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
            unidadeId: {
                get() {
                    return this.$store.state.unidadeId;
                },
                set(value) {
                    this.alterandoUnidade = false;
                    this.$store.commit('SET_UNIDADE', value);
                }
            },
            unidadeNome() {
                const unidade = this.unidades?.find(x => x.id == this.unidadeId);
                return unidade?.nome;
            },
            podeAcessarOrcamentos() {
                return this.isInRole('prd-orcamentos-consultar') || this.isInRole('prd-orcamentos-alterar');
            },
            podeAcessarAnalise() {
                return this.isInRole('prd-analise-consultar') || this.isInRole('prd-analise-alterar');
            },
            podeAcessarProducao() {
                return this.isInRole('prd-pedidos-consultar') || this.isInRole('prd-pedidos-produzir') || this.isInRole('prd-pedidos-entregar');
            },
            temAcessoUsiFlow() {
                return this.isInRole('prd-dashboard-consultar') || this.podeAcessarOrcamentos || this.podeAcessarAnalise || this.podeAcessarProducao;
            },
        },
        created(){
            this.getImage();
        },
        methods: {

            getImage() {
                if (!this.foto){                    
                    this.foto = '/api/manutencao/funcionarioFoto?id=' + this.usuario.funcionarioId +`&_cl=${new Date().getTime()}`;
                }

                return this.foto;
            },            
            ...mapActions([
                'logout'
            ]),
            ...mapMutations('componentes', [
                'HANDLE_RESIZE',
                'SET_SIDEBAR',
            ])
        }
}
</script>

<style scoped>
.app-sidebar {
    position: sticky;
    top: 3.25rem;
    height: calc(100vh - 3.25rem);
    min-width: 220px;
    overflow-y: auto;
    padding: 0.8rem !important;
    border-right: 1px solid var(--border-soft);
    background: #fff;
    box-shadow: 4px 0 18px rgba(18, 48, 75, 0.035);
}
.sidebar-close-row {
    min-height: 1.2rem;
    margin-bottom: 0.2rem;
}
.sidebar-avatar {
    overflow: hidden;
    margin-bottom: 0.65rem;
    border: 3px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 2px var(--brand-teal-100), var(--shadow-sm);
}
.sidebar-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.sidebar-user-name {
    color: var(--text-strong);
    font-weight: 800;
}
.sidebar-user-role {
    margin-top: 0.15rem;
    color: var(--text-muted);
}
.menu-list a {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin: 0.15rem 0;
    padding: 0.65rem 0.75rem;
    border-radius: var(--radius-sm);
    color: var(--text-body);
    font-weight: 700;
}
.menu-list a:hover {
    background: var(--surface-muted);
    color: var(--brand-navy-800);
}
.menu-list a.is-active {
    background: var(--brand-teal-100);
    color: var(--brand-navy-800);
    box-shadow: inset 3px 0 var(--brand-teal-600);
}
.dropdown-divider {
    margin: 0.8rem 0;
    background: var(--border-soft);
}
.prd-menu-label { padding: .35rem .75rem; color: var(--text-muted); font-size: .68rem; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; }
.prd-menu-separator { height: 1px; margin: .6rem .75rem; background: var(--border-soft); }
@media (max-width: 768px) {
    .app-sidebar {
        position: fixed;
        z-index: 35;
        top: 3.25rem;
        bottom: 0;
        left: 0;
        width: min(86vw, 300px);
    }
}
</style>
